import classNames from 'classnames';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import React, { useCallback } from 'react';
import { ReactComponent as SvgMarker } from 'public/assets/icons/marker.svg';

import { ISkiResortShop } from 'api/resort/types';
import { Button } from 'components/blocks/Button';
import { useAnalytics } from 'util/analytics';
import { ReactComponent as SvgDeal } from 'public/assets/icons/deal.svg';

import { ITASkiRentalReq } from 'components/common/PlanYourTrip/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { useDistanceFormatter } from 'i18n/unitFormat';
import styles from './styles.module.scss';
import ARLogoSrc from './AR-Logo.png';

export interface IProps {
  query: ITASkiRentalReq;
  shop: ISkiResortShop;
  className?: string;
}

export const SkiRentalShop = ({
  className,
  shop,
}: IProps) => {
  const { t } = useOTSTranslation('common');
  const address = [shop.town, shop.street].filter((s) => !!s).join(', ');
  const {
    linkToShop, discount, image, title, distance,
  } = shop;

  const dt = useDistanceFormatter('kmOrMile');

  const a = useAnalytics();

  const onClick = useCallback(() => {
    a.skiRentalViewDeal(shop.id || shop.uuid);
  }, [a, title]);

  return (
    <div className={classNames(styles.box, className)}>
      <BoxWithShadow className={styles.wrapper}>
        <div className={styles.imageWrapper}>
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a
            className={styles.image}
            href={linkToShop}
            target="_blank"
            rel="nofollow"
          >
            {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
            <figure
              className={styles.image}
              style={{ backgroundImage: `url(${image})` }}
            />
            {distance && (
              <span className={styles.resortPin}>
                <span><SvgMarker height="15px" width="12px" /></span>
                <span>{dt(distance / 1000)}</span>
              </span>
            )}
            <img className={styles.arLogo} src={ARLogoSrc.src} alt="AlpineResort Logo" />
          </a>
        </div>
        <div className={styles.info}>
          <h3>
            <span>{title}</span>
          </h3>
          <span className={styles.address}>{address}</span>
          <div className={styles.footer}>
            <div className={styles.discount}>
              {discount ? `−${(discount * 100).toFixed(0)}% ${t('resort.skiRental.off')}` : ''}
            </div>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a href={linkToShop} target="_blank" rel="nofollow">
              <Button className={styles.button} onClick={onClick}>
                <SvgDeal />
                <span>{t('resort.lodging.viewDeal')}</span>
              </Button>
            </a>
          </div>
        </div>
      </BoxWithShadow>
    </div>
  );
};
